module.exports = __webpack_public_path__ + "img/lj.0ce776a3.png";